class TwitterAnalytics {
  clientThankYou(order) {
    this._trigger(order.campaign.pixels.campaign);

    if (order.campaign.pixels.campaign.twitter !== order.campaign.pixels.global.twitter) {
      this._trigger(order.campaign.pixels.global);
    }
  }

  _trigger(pixels) {
    if (pixels.twitter) {
      window.dataLayer.push({ 'clientTwitterPixelId': pixels.twitter });
      window.dataLayer.push({ 'event': 'client-twitter-tracking' });
    }
  }
}

export default new TwitterAnalytics();


// WEBPACK FOOTER //
// ./source/client/analytics/twitter.js